// @ts-nocheck
import store from "../../../../store"
import { Network } from "../../.."
import APIWrapper from "../../APIWrapper"
import { formatDate, getCurrency } from "../../../formating"

class ContributionAttributes extends APIWrapper {
  constructor(props) {
    super()
    Object.assign(this, props)
  }
}

class Contribution extends ContributionAttributes {
  static async getAll({ user, params: { processed } }) {
    try {
      const [contribution, recurringContribution, bankAccounts] = await Promise.all([
        Network.AxiosWrapper({
          method: "GET",
          target: `contribution/v2/plan?includeBankAccount=true&includeProcessed=${processed}`,
          token: user.token
        }),

        Network.AxiosWrapper({
          method: "GET",
          target: `contribution/v2/recurring/plan?includeBankAccount=true`,
          token: user.token
        }),

        Network.API.Customer.BankAccount.getAll({ options: [] })
      ])

      const contributionData = contribution?.data?.data || []
      const recurringContributionData = recurringContribution?.data?.data || []
      const combinedContributionData = [...contributionData, ...recurringContributionData]

      const contributions = { pending: new Map(), recurring: new Map() }

      combinedContributionData.forEach((contribution) => {
        if (contribution.id?.includes("recurring")) {
          let fundingSource = contribution.fundingSource.id === "Employer" ? "Employer" : "ACH"
          contributions.recurring.set(contribution.id, new Contribution({ ...contribution, fundingSource }))
        } else {
          let fundingSource =
            contribution.category.id === "EMPLOYER_CONTRIBUTION"
              ? "Employer"
              : bankAccounts.get(contribution.bankAccountId)?.nickname

          contributions.pending.set(contribution.id, new Contribution({ ...contribution, fundingSource }))
        }
      })

      return contributions
    } catch (error) {
      console.error(error)
    }
  }

  static async getOne({ user, params: { id, processed } }) {
    try {
      const [contributionResponse, bankAccounts] = await Promise.all([
        Network.AxiosWrapper({
          method: "GET",
          target: `contribution/v2/${id}?includeBankAccount=true&includeProcessed=${processed}`,
          token: user.token
        }),

        Network.API.Customer.BankAccount.getAll({ options: [] })
      ])

      let contribution = contributionResponse?.data
      let fundingSource = ""

      if (contribution.category.id === "EMPLOYER_CONTRIBUTION") fundingSource.nickname = "Employer"
      else fundingSource = bankAccounts.get(contribution.bankAccountId)

      return new Contribution({ ...contribution, fundingSource })
    } catch (error) {
      console.error(error)
    }
  }

  static async getOneRecurring({ user, params: { id, processed } }) {
    try {
      const response = await Network.AxiosWrapper({
        method: "GET",
        target: `contribution/v2/${id}?includeBankAccount=true&includeProcessed=${processed}`,
        token: user.token
      })

      let contribution = response?.data
      let fundingSource = {}

      if (contribution.fundingSource.id === "Employer") fundingSource.nickname = "Employer"
      else fundingSource.nickname = "ACH"

      return new Contribution({ ...contribution, fundingSource })
    } catch (error) {
      console.error(error)
    }
  }

  static async create({ params, payload }) {
    try {
      const url = params.isRecurring ? "contribution/v2/recurring/plan" : "/contribution/v2/plan"
      await Network.AxiosWrapperV2.post({ url, data: payload })
    } catch (error) {
      console.error(error)
    }
  }

  get tableValues() {
    return {
      date: formatDate({ data: this.createdTs, actions: ["display"] }),
      created: formatDate({ data: this.createdTs, actions: ["display"] }),
      nextDate: formatDate({ data: this.nextTs, actions: ["display"] }),
      fundingSource: this.fundingSource,
      fundingSourceStr: `${this.isRollover ? "Rollover - " : ""}${this.fundingSource.displayName}`,

      amount: getCurrency({
        amount: this.amount,
        actions: ["divide"]
      })
    }
  }

  async update() {
    await Network.AxiosWrapperV2.send({
      ...this.links.update,
      data: this
    })
  }

  async delete() {
    try {
      if (this.links.delete) {
        const contributionType = this.recurringContributionId ? "recurring" : "pending"

        await Network.AxiosWrapperV2.send({
          ...this.links.delete
        })

        store.setNotification("notification", true, {
          msg: `Successfully removed ${contributionType} contribution.`
        })

        return true
      }
    } catch (err) {
      console.error(err)
    }
    return false
  }
}

export default Contribution
